class InventoryThresholdBlock {
    constructor(block) {
      this.block = block;
      this.textEl = block.querySelector('[data-inventory-threshold-text]');
      this.variantJson = document.querySelector('[data-inventory-threshold-variants]');

      if (!this.block || !this.textEl || !this.variantJson) return;

      this.variants = JSON.parse(this.variantJson.textContent);
      this.threshold = Number(this.block.dataset.threshold || 5);
      this.message = this.block.dataset.message || 'Only [count] left in stock';

      this.bindEvents();
      this.updateFromUrl();
    }

    bindEvents() {
      document.addEventListener('change', () => {
        setTimeout(() => {
          this.updateFromUrl();
        }, 100);
      });

      document.addEventListener('variant:change', (event) => {
        const variant = event.detail?.variant;

        if (variant?.id) {
          this.updateByVariantId(variant.id);
        }
      });

      document.addEventListener('product:variant-change', (event) => {
        const variant = event.detail?.variant;

        if (variant?.id) {
          this.updateByVariantId(variant.id);
        }
      });
    }

    updateFromUrl() {
      const url = new URL(window.location.href);
      const variantId = url.searchParams.get('variant');

      if (!variantId) return;

      this.updateByVariantId(variantId);
    }

    updateByVariantId(variantId) {
      const variant = this.variants.find((item) => String(item.id) === String(variantId));

      if (!variant) return;

      const inventory = Number(variant.inventory_quantity);

      const shouldShow =
        variant.available &&
        variant.inventory_management &&
        variant.inventory_policy === 'deny' &&
        inventory > 0 &&
        inventory <= this.threshold;

      if (shouldShow) {
        this.textEl.textContent = this.message.replace('[count]', inventory);
        this.block.hidden = false;
      } else {
        this.textEl.textContent = '';
        this.block.hidden = true;
      }
    }
  }

  document.querySelectorAll('[data-inventory-threshold-block]').forEach((block) => {
    new InventoryThresholdBlock(block);
  });